import React from 'react';
import { DropdownToggleProps } from 'react-bootstrap/DropdownToggle';
import DownArrow from '../../svgs/downarrow.svg';

interface ArrowToggleProps extends DropdownToggleProps {
    direction?: 'right';
}

const ArrowToggle = React.forwardRef<HTMLButtonElement, ArrowToggleProps>(({ children, direction, ...props }, ref) => {
    return (
        <button {...props} className="dropdown-item nav-link" ref={ref} type="button">
            {children && <span className="pr-2">{children}</span>}
            {/* Use static classNames for header+footer api integration */}
            {direction === 'right' ? (
                <DownArrow className="rotate-270 size-75" />
            ) : (
                <DownArrow className="collapse-flip size-75" />
            )}
        </button>
    );
});

ArrowToggle.displayName = 'ArrowToggle';

export { ArrowToggle };
